import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isAuth } from "../../../../auth/helpers";
import Premium from "./Premium";
import FilterCard from "./FilterCard";

import {
  getUserFiltersData,
  deleteUserFilterByMake,
  saveUserFiltersData
} from "../../reduxStore/entities/userFiltersStore";

const PageThree = ({ selectedCars, onRemoveModel, onAddMore, maxMakesAllowed = 3 }) => {
  const dispatch = useDispatch();
  const { userid } = isAuth();
  const { filters: userFilters } = useSelector((state) => state.userFiltersStore);

  useEffect(() => {
    dispatch(getUserFiltersData());
  }, [dispatch]);

  useEffect(() => {
    if (selectedCars.length > 0) {
      dispatch(saveUserFiltersData({ selectedCars, userid, maxMakesAllowed }));
    }
  }, [selectedCars, dispatch, userid, maxMakesAllowed]);

  const handleDelete = (id_car_make) => {
    dispatch(deleteUserFilterByMake(id_car_make));
    onRemoveModel(id_car_make);
  };

  const remainingMakes = maxMakesAllowed - userFilters.length;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Asortiman</h2>
      {userFilters.length > 0 ? (
        userFilters.slice(0, maxMakesAllowed).map((filter, index) => (
          <FilterCard
            key={filter.id || index}
            filter={filter}
            onDelete={() => handleDelete(filter.id_car_make)}
          />
        ))
      ) : (
        <p>Nema asortimana za prikaz.</p>
      )}

      {remainingMakes > 0 ? (
        <button onClick={onAddMore} style={styles.addButton}>
          Dodaj marku i model
        </button>
      ) : (
        <Premium onClick={() => console.log("Kliknuto za premium")} />
      )}
    </div>
  );
};

export default PageThree;

const styles = {
  container: {
    padding: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 20,
  },
  addButton: {
    backgroundColor: "#000",
    color: "#fff",
    borderRadius: 6,
    padding: "10px 20px",
    border: "none",
    cursor: "pointer",
    fontSize: 16,
    fontWeight: "bold",
    marginRight: 10,
  },
};
